import { ArticleDetail } from "./ArticleDetail";
import { Header } from "./Header";
import { OutboundLink } from "./Map";
import { ViewSelector } from "./ViewSelector";

const byline = JSON.parse(process.env.REACT_APP_AUTHOR);

export const Overlay = ({ selectedArticle, referrer }) => (
  <div className="map-overlay" id="main-map-overlay">
    <Header referrer={referrer} />
    <h2 className="chart-title">
      We Asked AI to Map Our Stories. Here are the Results.
    </h2>
    <span className="chart-note byline-content">
      By{" "}
      {byline.map((author, i) => (
        <span key={i} className="author">
          <OutboundLink to={author.url} referrer={referrer}>
            {author.name}
          </OutboundLink>
          {i < byline.length - 2 ? ", " : i < byline.length - 1 ? " and " : ""}
        </span>
      ))}
    </span>
    <p className="chart-note  byline-content source-content">
      As an experiment, we used ChatGPT to determine key locations in each of
      our stories from April 2019 through September 2023, and created a map of
      the data. The system was able to connect 2,773 out of 4,159 stories to a
      place.
    </p>
    <div
      className="chart-note byline-content secondary-content"
      //style={{ marginLeft: "5px" }}
    >
      <OutboundLink to="https://www.thecity.nyc/2024/02/29/chatgpt-map-stories-nyc/" referrer={referrer}>
        <b>Read more about the experiment here.</b>
      </OutboundLink>
    </div>

    <div
      className="chart-note byline-content secondary-content"
      //style={{ marginLeft: "5px" }}
    ></div>

    <div style={{ marginTop: "55px" }}>
      <ViewSelector isMobile />
      {/*does this isMobile act as a value or as the hook - check that */}
    </div>
    {/* <div className="map-geocoder-placeholder" /> */}
    <ArticleDetail selectedArticle={selectedArticle} referrer={referrer} />
  </div>
);
